/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Team_Relationship_LabelInputs */



/**
* | output |
* | --- |
* | "Who {name} is to you" |
*
* @param {Team_Relationship_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_relationship_label = /** @type {((inputs: Team_Relationship_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Relationship_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Wie ${i?.name} voor je is`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Qui est ${i?.name} pour vous`)
	return /** @type {LocalizedString} */ (`Who ${i?.name} is to you`)
});